import './Activity.css';

const Activity = ({name, email}) => {

    return (

        <div className="activity-card">

            <h3>{name}</h3>

            <p>{email}</p>

        </div>

    );
}

export default Activity;